import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">
                Geri Dön
              </span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">
              Çerez Politikası
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600">
              <strong>Son Güncelleme:</strong> 15 Ocak 2024
            </p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              1. Çerez Nedir?
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Çerezler, web sitemizi ziyaret ettiğinizde cihazınıza (bilgisayar, tablet, 
              telefon) yerleştirilen küçük metin dosyalarıdır. Bu dosyalar, web sitesinin 
              sizi tanımasını ve deneyiminizi iyileştirmesini sağlar.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Çerezler, web sitesinin daha hızlı yüklenmesini, güvenliğini artırmasını 
              ve size kişiselleştirilmiş içerik sunmasını sağlar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              2. Hangi Çerezleri Kullanıyoruz?
            </h2>
            
            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.1 Gerekli Çerezler
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu çerezler web sitesinin temel işlevlerini yerine getirmek için gereklidir 
              ve devre dışı bırakılamaz.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mb-4">
              <ul className="list-disc pl-6 text-gray-700">
                <li><strong>session_id:</strong> Oturum yönetimi için</li>
                <li><strong>csrf_token:</strong> Güvenlik için</li>
                <li><strong>language:</strong> Dil tercihi için</li>
                <li><strong>theme:</strong> Tema tercihi için</li>
              </ul>
            </div>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.2 Analitik Çerezler
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu çerezler web sitesinin nasıl kullanıldığını anlamamıza yardımcı olur.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mb-4">
              <ul className="list-disc pl-6 text-gray-700">
                <li><strong>_ga:</strong> Google Analytics - Ziyaretçi sayısı</li>
                <li><strong>_gid:</strong> Google Analytics - Oturum bilgileri</li>
                <li><strong>_gat:</strong> Google Analytics - Hız sınırlaması</li>
                <li><strong>page_views:</strong> Sayfa görüntüleme sayısı</li>
              </ul>
            </div>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.3 Pazarlama Çerezleri
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu çerezler size kişiselleştirilmiş reklamlar göstermek için kullanılır.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <ul className="list-disc pl-6 text-gray-700">
                <li><strong>fbp:</strong> Facebook Pixel - Reklam takibi</li>
                <li><strong>_fbp:</strong> Facebook - Kullanıcı davranışı</li>
                <li><strong>ads_prefs:</strong> Reklam tercihleri</li>
                <li><strong>marketing_consent:</strong> Pazarlama izni</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              3. Çerezlerin Amacı
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-blue-900 mb-3">
                  🚀 Performans
                </h4>
                <ul className="list-disc pl-6 text-blue-800">
                  <li>Sayfa yükleme hızını artırma</li>
                  <li>Önbellek yönetimi</li>
                  <li>Sunucu yükünü azaltma</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-green-900 mb-3">
                  🔒 Güvenlik
                </h4>
                <ul className="list-disc pl-6 text-green-800">
                  <li>Oturum güvenliği</li>
                  <li>Dolandırıcılık önleme</li>
                  <li>Güvenli kimlik doğrulama</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-purple-900 mb-3">
                  📊 Analitik
                </h4>
                <ul className="list-disc pl-6 text-purple-800">
                  <li>Kullanım istatistikleri</li>
                  <li>Performans analizi</li>
                  <li>Hata takibi</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-orange-900 mb-3">
                  🎯 Kişiselleştirme
                </h4>
                <ul className="list-disc pl-6 text-orange-800">
                  <li>Dil tercihleri</li>
                  <li>Tema seçenekleri</li>
                  <li>İçerik önerileri</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              4. Çerez Yönetimi
            </h2>
            
            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              4.1 Tarayıcı Ayarları
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Çerezleri tarayıcı ayarlarınızdan kontrol edebilirsiniz:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mb-4">
              <ul className="list-disc pl-6 text-gray-700">
                <li><strong>Chrome:</strong> Ayarlar → Gizlilik ve Güvenlik → Çerezler</li>
                <li><strong>Firefox:</strong> Ayarlar → Gizlilik ve Güvenlik → Çerezler</li>
                <li><strong>Safari:</strong> Tercihler → Gizlilik → Çerezler</li>
                <li><strong>Edge:</strong> Ayarlar → Çerezler ve site izinleri</li>
              </ul>
            </div>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              4.2 Çerez Tercihleri
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Web sitemizde çerez tercihlerinizi yönetebilirsiniz:
            </p>
            <div className="bg-blue-50 p-6 rounded-lg">
              <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors">
                Çerez Ayarlarını Aç
              </button>
              <p className="text-blue-800 mt-3 text-sm">
                Bu buton ile çerez tercihlerinizi değiştirebilirsiniz.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              5. Üçüncü Taraf Çerezler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Web sitemizde aşağıdaki üçüncü taraf hizmetlerin çerezleri kullanılabilir:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-gray-200 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Google Analytics
                </h4>
                <p className="text-gray-700 text-sm mb-3">
                  Web sitesi kullanım istatistiklerini analiz etmek için kullanılır.
                </p>
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm hover:underline">
                  Google Gizlilik Politikası →
                </a>
              </div>
              
              <div className="border border-gray-200 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Facebook Pixel
                </h4>
                <p className="text-gray-700 text-sm mb-3">
                  Reklam performansını ölçmek ve hedefleme yapmak için kullanılır.
                </p>
                <a href="https://www.facebook.com/policy.php" target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm hover:underline">
                  Facebook Gizlilik Politikası →
                </a>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              6. Çerez Süreleri
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-2 text-left">Çerez Türü</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Süre</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Açıklama</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Oturum Çerezleri</td>
                    <td className="border border-gray-300 px-4 py-2">Tarayıcı kapanana kadar</td>
                    <td className="border border-gray-300 px-4 py-2">Geçici oturum bilgileri</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Kalıcı Çerezler</td>
                    <td className="border border-gray-300 px-4 py-2">1-2 yıl</td>
                    <td className="border border-gray-300 px-4 py-2">Tercih ve ayar bilgileri</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Analitik Çerezler</td>
                    <td className="border border-gray-300 px-4 py-2">2 yıl</td>
                    <td className="border border-gray-300 px-4 py-2">Kullanım istatistikleri</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Pazarlama Çerezleri</td>
                    <td className="border border-gray-300 px-4 py-2">90 gün</td>
                    <td className="border border-gray-300 px-4 py-2">Reklam ve hedefleme</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              7. Çerezleri Devre Dışı Bırakma
            </h2>
            <div className="bg-yellow-50 border border-yellow-200 p-6 rounded-lg">
              <h3 className="font-poppins font-heading-semibold text-lg text-yellow-900 mb-3">
                ⚠️ Önemli Uyarı
              </h3>
              <p className="text-yellow-800 leading-relaxed mb-4">
                Çerezleri devre dışı bırakırsanız, web sitemizin bazı özellikleri 
                düzgün çalışmayabilir. Özellikle gerekli çerezler devre dışı bırakıldığında:
              </p>
              <ul className="list-disc pl-6 text-yellow-800">
                <li>Giriş yapamayabilirsiniz</li>
                <li>Tercihleriniz kaydedilmez</li>
                <li>Bazı sayfalar yüklenmeyebilir</li>
                <li>Güvenlik özellikleri çalışmayabilir</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              8. Güncellemeler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu Çerez Politikası zaman zaman güncellenebilir. Önemli değişiklikler 
              olduğunda web sitemizde duyurulur.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Son güncelleme tarihi her zaman sayfanın üst kısmında belirtilir.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              9. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Çerez politikamız hakkında sorularınız için:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon:</strong> +90 507 588 04 81<br />
                <strong>Adres:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE
              </p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default CookiePolicyPage; 